import BgImage1 from '../../assets/motor-vehicle/motor-vehicle-bg1.png'
import SMInsuranceRenewal from '../../containers/MotorVehicle/InsuranceRenewal'
import SMHomeContactUs from '../../containers/Home/ContactUs'
import { Box, Typography, } from '@mui/material'
import FAQItem from '../../components/ui/FAQ'
import axios from 'axios'
import { FAQUrl } from '../../common/url'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { App_Language_key } from '../../common/config'
import { isTablet } from 'react-device-detect'

export const MotorVehicleScreen: React.FC = () => {

    const { t } = useTranslation()

    const [data, setData] = useState(null)

    useEffect(() => {
        (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    const fetchList = async () => {
        try {
            var url = FAQUrl + '?publicationState=live&sort=sequence:ASC&filters[language][$eq]=' + language + '&filters[category][$eq]=Insurance'
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const renderFaqAccordion = () => (
        <Box sx={{
            width: '100%',
            paddingLeft: '72px',
            paddingRight: '72px',
            paddingTop: '60px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF'
        }}>
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingBottom={'40px'}>
                {t('t164')}
            </Typography>
            <FAQItem data={data}></FAQItem>
        </Box>
    )
    // ======================= VIEWS
    return (
        <>
            <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage1})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: '457px',
            }}>

                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={50} fontWeight={600} color={'#FBBF23'} textAlign={'center'}>
                        {t('t253')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '16px'}}>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t254')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t255')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                        <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t256')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
       
            <SMInsuranceRenewal />
            {renderFaqAccordion()}
            <Box sx={{
                paddingLeft: isTablet ? '32px' : '12px',
                paddingRight: isTablet ? '32px' : '12px',
            }}>
                <SMHomeContactUs />
            </Box>
            
        </>
    )
}

// ======================= EXPORT
export default MotorVehicleScreen
